var _circle, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKuveyt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 19,
    cy: 19,
    r: 19,
    fill: "#22262F"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_940_1331)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.2311 30.9295L16.8628 31.7805L15.9618 29.589L18.2311 30.9239V30.9295ZM16.0508 24.9168L18.2478 26.274L16.9518 27.1528L16.0563 24.9168H16.0508ZM15.9785 20.2001L18.2812 21.5907L16.9296 22.5696L15.9785 20.2057V20.2001ZM19.6272 23.9991L21.8743 22.603L21.0011 24.8946L19.6217 23.9991H19.6272ZM16.0118 27.264L20.2279 29.8226L18.9486 30.6514L16.7627 29.4221L16.0118 27.2696V27.264ZM17.6638 27.4142L21.8354 24.8946L21.1624 26.9247L18.9931 28.3931L17.6638 27.4198V27.4142ZM16.0174 22.653L20.2669 25.0948L18.8652 26.0515L16.7405 24.7666L16.0118 22.653H16.0174ZM17.6026 22.8032L21.8354 20.2557L21.0734 22.4361L19.0098 23.682L17.6026 22.8032ZM17.4691 20.3614H20.2947L18.9486 21.4238L17.4636 20.3614H17.4691ZM19.6217 28.5433L21.8688 27.1472L20.9955 29.4388L19.6161 28.5433H19.6217ZM18.8763 18.7595C18.8763 18.7595 16.6014 12.1907 16.1676 10.878C15.9896 10.3385 15.9173 9.88237 16.2566 9.43183L18.8763 6L21.4905 9.43183C21.8354 9.88237 21.7575 10.3385 21.5795 10.878C21.1457 12.1962 18.8763 18.7595 18.8763 18.7595ZM31.7471 19.5104H19.6717L25.1727 16.6849C28.2374 15.1052 29.2553 16.4234 30.3788 17.814L31.7471 19.5104ZM19.4047 18.9041L23.1981 12.1017C23.6876 11.2228 24.9502 10.7834 26.0515 11.4453L30.3176 14.0039H28.1762C27.2362 14.0095 26.4909 14.371 25.8123 14.8049L19.4103 18.9041H19.4047ZM6 19.5104L7.37385 17.814C8.49183 16.4234 9.5097 15.1052 12.5744 16.6849L18.0754 19.516H6V19.5104ZM18.3368 18.9041L11.9348 14.8049C11.2562 14.371 10.5053 14.0095 9.56533 14.0095H7.42947L11.6901 11.4398C12.7914 10.7779 14.054 11.2173 14.5434 12.0961L18.3368 18.8986V18.9041ZM17.4135 32.2421L21.8298 29.6279L20.9844 32.1643C20.3058 32.2644 19.6161 32.3144 18.9097 32.3144C18.4035 32.3144 17.903 32.2866 17.4079 32.2366L17.4135 32.2421Z",
    fill: "#4A9D86"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_940_1331"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 25.7527,
    height: 26.32,
    fill: "white",
    transform: "translate(6 6)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKuveyt);
export default __webpack_public_path__ + "static/media/kuveyt.c2a6e29058c43101bd1dbdc687920bcb.svg";
export { ForwardRef as ReactComponent };